import { Injectable,Injector } from "@angular/core";

import { FvmsMapApiVendor } from "./fvms.map.api.vendor.enum";
import { FvmsMapApiInterface } from "./fvms.map.api.interface";
import { FvmsMapApiServiceKakao } from "./fvms.map.api.service.kakao";
import { FvmsMapApiServiceGoogle } from "./fvms.map.api.service.google";

@Injectable({providedIn: 'root'})
export class FvmsMapApiProvidor {
    mapApiVendor:FvmsMapApiVendor = FvmsMapApiVendor.KAKAO;
    listMapApiVendor:Map<string,any>;

    constructor(
        private injector: Injector
    ) {
        this.listMapApiVendor = new Map([
            [FvmsMapApiVendor.KAKAO,FvmsMapApiServiceKakao]
            ,[FvmsMapApiVendor.GOOGLE,FvmsMapApiServiceGoogle]
        ]);
    }

    getMapApiVendor(){
        return this.mapApiVendor;
    }
    setMapApiVendor(mapApiVendor:FvmsMapApiVendor){
        this.mapApiVendor = mapApiVendor;
    }

    getMapApiService():FvmsMapApiInterface{
        // let service = this.listMapApiVendor.get(this.mapApiVendor);
        // return this.injector.get(service);
        switch(this.mapApiVendor){
            case FvmsMapApiVendor.GOOGLE:
                return new FvmsMapApiServiceGoogle();
            default:
                return new FvmsMapApiServiceKakao();
        }
    }
}